import { Query } from "components/common"
import { FETCH_ACTOR } from "lib/graphql"

export default ({id, children, renderLoading}) => (
	<Query query={FETCH_ACTOR} options={{variables: { id }}} renderLoading={renderLoading}>
		{({cms: { actors: { items: actors } }}) => children(actors[0]) }
	</Query>
)
